const HAS_CLOSED_INITIAL_MESSAGE = 'endion-chatbot-has-closed-initial-message';

export function getHasClosedInitialMessage() {
  return sessionStorage.getItem(HAS_CLOSED_INITIAL_MESSAGE);
}

export function setHasClosedInitialMessage() {
  sessionStorage.setItem(HAS_CLOSED_INITIAL_MESSAGE, 'true');
}
